import React, { MutableRefObject, forwardRef, useEffect } from 'react';
import { Formik, FormikProps } from 'formik';
import { Grid } from '@material-ui/core';

import { Network } from 'api';
import { FormikNotifier } from 'components';
import { useContent } from 'hooks';
import { TWITTER_LIMIT, TWITTER_LIMIT_WITH_LINK } from 'app-constants';

import { usePostContext } from 'features/posting';
import { isPhotoOnly } from 'features/content/helpers';
import { Share } from 'features/sharing/types';
import useInitialValues from 'features/sharing/useInitialValues';

import Scheduler from './Scheduler';
import Connections from '../Connections';
import { sharingSchema } from '../../validations';

interface Props {
  onUpdate: (values: Share) => void;
}

const ShareForm = forwardRef<FormikProps<Share>, Props>((props, ref) => {
  const initialShareValues = useInitialValues();
  const content = useContent();
  const { state } = usePostContext();

  const typedFormikShareRef = ref as MutableRefObject<FormikProps<Share>>;
  const { values, setFieldValue } = typedFormikShareRef.current;

  useEffect(() => {
    values.items.forEach((item, index) => {
      setFieldValue(`items[${index}].state.content`, content);

      if (item.state.networkMeta.provider === Network.Twitter) {
        setFieldValue(
          `items[${index}].state.limit`,
          state.validUrl ? TWITTER_LIMIT_WITH_LINK : TWITTER_LIMIT
        );
      }
    });
  }, [state.validUrl]);

  useEffect(() => {
    values.items.forEach((item, index) => {
      setFieldValue(`items[${index}].state.content`, content);

      const isFacebook = item.state.networkMeta.provider === Network.Facebook;
      if (isFacebook && isPhotoOnly(content)) {
        setFieldValue(`items[${index}].state.active`, false);
      }
    });
  }, [content.content_object.photos]);

  return (
    <Formik
      innerRef={ref}
      onSubmit={() => undefined}
      initialValues={initialShareValues}
      validationSchema={sharingSchema}
      options={{ uiState: state }}
    >
      <FormikNotifier onChange={props.onUpdate}>
        <Connections>
          <Grid item>
            <Scheduler />
          </Grid>
        </Connections>
      </FormikNotifier>
    </Formik>
  );
});

export default ShareForm;
